// Auto-generated by scripts/build-roster.mts. Do not edit by hand.
// Run `npm run build:roster` to regenerate from apps/server/src/domain/.

export type EntityKind = "tower" | "unit";
export type EntityGate = { id: string; label: string; techName: string };
export type EntityCard = {
  key: string;
  name: string;
  kind: EntityKind;
  tier: number;
  summary: string;
  tags: string[];
  /** How to unlock this entity. Rendered as a pill in the wiki card. */
  gate: EntityGate | null;
  details: [string, string][];
};

export const ROSTER: Record<string, EntityCard> = {
  "arrow": {
    "key": "arrow",
    "name": "Arrow",
    "kind": "tower",
    "tier": 1,
    "summary": "10 g · Ground + air",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "200"
      ],
      [
        "Damage",
        "30"
      ],
      [
        "Cooldown",
        "3.0 s"
      ],
      [
        "DPS",
        "10"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground + air"
      ]
    ]
  },
  "ballista": {
    "key": "ballista",
    "name": "Ballista",
    "kind": "tower",
    "tier": 1,
    "summary": "30 g (from Arrow) · Ground + air",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "300"
      ],
      [
        "Damage",
        "80"
      ],
      [
        "Cooldown",
        "2.0 s"
      ],
      [
        "DPS",
        "40"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground + air"
      ]
    ]
  },
  "cannon": {
    "key": "cannon",
    "name": "Cannon",
    "kind": "tower",
    "tier": 1,
    "summary": "30 g (from Arrow) · Ground only",
    "tags": [],
    "gate": {
      "id": "t1_b1_cannon",
      "label": "Technology",
      "techName": "Cannon"
    },
    "details": [
      [
        "HP",
        "300"
      ],
      [
        "Damage",
        "43 per target"
      ],
      [
        "Cooldown",
        "2.5 s"
      ],
      [
        "DPS",
        "17"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground only"
      ],
      [
        "Splash radius",
        "1.7 cells"
      ]
    ]
  },
  "arbalest": {
    "key": "arbalest",
    "name": "Arbalest",
    "kind": "tower",
    "tier": 2,
    "summary": "200 g (from Ballista) · Ground + air",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "525"
      ],
      [
        "Damage",
        "360"
      ],
      [
        "Cooldown",
        "1.5 s"
      ],
      [
        "DPS",
        "240"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground + air"
      ]
    ]
  },
  "mortar": {
    "key": "mortar",
    "name": "Mortar",
    "kind": "tower",
    "tier": 2,
    "summary": "200 g (from Cannon) · Ground only",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "525"
      ],
      [
        "Damage",
        "260 per target"
      ],
      [
        "Cooldown",
        "2.5 s"
      ],
      [
        "DPS",
        "104"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground only"
      ],
      [
        "Splash radius",
        "1.7 cells"
      ]
    ]
  },
  "harpoon": {
    "key": "harpoon",
    "name": "Harpoon",
    "kind": "tower",
    "tier": 2,
    "summary": "200 g (from Ballista) · Air only",
    "tags": [],
    "gate": {
      "id": "t2_b3_harpoon",
      "label": "Technology",
      "techName": "Harpoon"
    },
    "details": [
      [
        "HP",
        "525"
      ],
      [
        "Damage",
        "457"
      ],
      [
        "Cooldown",
        "1.5 s"
      ],
      [
        "DPS",
        "305"
      ],
      [
        "Range",
        "4 cells"
      ],
      [
        "Targets",
        "Air only"
      ]
    ]
  },
  "polybolos": {
    "key": "polybolos",
    "name": "Polybolos",
    "kind": "tower",
    "tier": 3,
    "summary": "1 300 g (from Arbalest) · Ground + air",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "750"
      ],
      [
        "Damage",
        "1 540"
      ],
      [
        "Cooldown",
        "1.0 s"
      ],
      [
        "DPS",
        "1 540"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground + air"
      ]
    ]
  },
  "howitzer": {
    "key": "howitzer",
    "name": "Howitzer",
    "kind": "tower",
    "tier": 3,
    "summary": "1 300 g (from Mortar) · Ground only",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "750"
      ],
      [
        "Damage",
        "1 671 per target"
      ],
      [
        "Cooldown",
        "2.5 s"
      ],
      [
        "DPS",
        "668"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground only"
      ],
      [
        "Splash radius",
        "1.7 cells"
      ]
    ]
  },
  "skyhook": {
    "key": "skyhook",
    "name": "Skyhook",
    "kind": "tower",
    "tier": 3,
    "summary": "1 300 g (from Harpoon) · Air only",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "750"
      ],
      [
        "Damage",
        "1 956"
      ],
      [
        "Cooldown",
        "1.0 s"
      ],
      [
        "DPS",
        "1 956"
      ],
      [
        "Range",
        "4 cells"
      ],
      [
        "Targets",
        "Air only"
      ]
    ]
  },
  "skorpion": {
    "key": "skorpion",
    "name": "Skorpion",
    "kind": "tower",
    "tier": 4,
    "summary": "9 000 g (from Polybolos) · Ground + air",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "975"
      ],
      [
        "Damage",
        "8 432"
      ],
      [
        "Cooldown",
        "0.8 s"
      ],
      [
        "DPS",
        "10 540"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground + air"
      ]
    ]
  },
  "culverin": {
    "key": "culverin",
    "name": "Culverin",
    "kind": "tower",
    "tier": 4,
    "summary": "9 000 g (from Howitzer) · Ground only",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "975"
      ],
      [
        "Damage",
        "11 436 per target"
      ],
      [
        "Cooldown",
        "2.5 s"
      ],
      [
        "DPS",
        "4 574"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground only"
      ],
      [
        "Splash radius",
        "1.7 cells"
      ]
    ]
  },
  "stormpike": {
    "key": "stormpike",
    "name": "Stormpike",
    "kind": "tower",
    "tier": 4,
    "summary": "9 000 g (from Skyhook) · Air only",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "975"
      ],
      [
        "Damage",
        "10 709"
      ],
      [
        "Cooldown",
        "0.8 s"
      ],
      [
        "DPS",
        "13 386"
      ],
      [
        "Range",
        "4 cells"
      ],
      [
        "Targets",
        "Air only"
      ]
    ]
  },
  "manticore": {
    "key": "manticore",
    "name": "Manticore",
    "kind": "tower",
    "tier": 5,
    "summary": "60 000 g (from Skorpion) · Ground + air",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "1 200"
      ],
      [
        "Damage",
        "35 270"
      ],
      [
        "Cooldown",
        "0.5 s"
      ],
      [
        "DPS",
        "70 540"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground + air"
      ]
    ]
  },
  "bombard": {
    "key": "bombard",
    "name": "Bombard",
    "kind": "tower",
    "tier": 5,
    "summary": "60 000 g (from Culverin) · Ground only",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "1 200"
      ],
      [
        "Damage",
        "76 536 per target"
      ],
      [
        "Cooldown",
        "2.5 s"
      ],
      [
        "DPS",
        "30 614"
      ],
      [
        "Range",
        "3 cells"
      ],
      [
        "Targets",
        "Ground only"
      ],
      [
        "Splash radius",
        "1.7 cells"
      ]
    ]
  },
  "skybreaker": {
    "key": "skybreaker",
    "name": "Skybreaker",
    "kind": "tower",
    "tier": 5,
    "summary": "60 000 g (from Stormpike) · Air only",
    "tags": [],
    "gate": null,
    "details": [
      [
        "HP",
        "1 200"
      ],
      [
        "Damage",
        "44 793"
      ],
      [
        "Cooldown",
        "0.5 s"
      ],
      [
        "DPS",
        "89 586"
      ],
      [
        "Range",
        "4 cells"
      ],
      [
        "Targets",
        "Air only"
      ]
    ]
  },
  "chicken": {
    "key": "chicken",
    "name": "Chicken",
    "kind": "unit",
    "tier": 1,
    "summary": "10 g · 30 HP · +2 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "10 g"
      ],
      [
        "HP per body",
        "30"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+2"
      ],
      [
        "Speed",
        "1.5 cells/s"
      ]
    ]
  },
  "peasant": {
    "key": "peasant",
    "name": "Peasant",
    "kind": "unit",
    "tier": 1,
    "summary": "25 g · 80 HP · +5 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "25 g"
      ],
      [
        "HP per body",
        "80"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+5"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "militia": {
    "key": "militia",
    "name": "Militia",
    "kind": "unit",
    "tier": 1,
    "summary": "60 g · 204 HP · +10 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "60 g"
      ],
      [
        "HP per body",
        "102"
      ],
      [
        "Send count",
        "2"
      ],
      [
        "Total HP per send",
        "204"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+10"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "elder": {
    "key": "elder",
    "name": "Elder",
    "kind": "unit",
    "tier": 1,
    "summary": "150 g · 657 HP · +22 income",
    "tags": [],
    "gate": {
      "id": "t1_b2_elder",
      "label": "Technology",
      "techName": "Elder"
    },
    "details": [
      [
        "Cost",
        "150 g"
      ],
      [
        "HP per body",
        "657"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+22"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "footmen": {
    "key": "footmen",
    "name": "Footmen",
    "kind": "unit",
    "tier": 1,
    "summary": "150 g · 570 HP · +25 income",
    "tags": [],
    "gate": {
      "id": "t1_b2_footmen",
      "label": "Technology",
      "techName": "Footmen"
    },
    "details": [
      [
        "Cost",
        "150 g"
      ],
      [
        "HP per body",
        "190"
      ],
      [
        "Send count",
        "3"
      ],
      [
        "Total HP per send",
        "570"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+25"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "squire": {
    "key": "squire",
    "name": "Squire",
    "kind": "unit",
    "tier": 2,
    "summary": "250 g · 939 HP · +34 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "250 g"
      ],
      [
        "HP per body",
        "939"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+34"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "soldier": {
    "key": "soldier",
    "name": "Soldier",
    "kind": "unit",
    "tier": 2,
    "summary": "600 g · 2 398 HP · +73 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "600 g"
      ],
      [
        "HP per body",
        "1 199"
      ],
      [
        "Send count",
        "2"
      ],
      [
        "Total HP per send",
        "2 398"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+73"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "lancer": {
    "key": "lancer",
    "name": "Lancer",
    "kind": "unit",
    "tier": 2,
    "summary": "1 300 g · 5 483 HP · +145 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "1 300 g"
      ],
      [
        "HP per body",
        "5 483"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+145"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "skyLancer": {
    "key": "skyLancer",
    "name": "Sky Lancer",
    "kind": "unit",
    "tier": 2,
    "summary": "1 650 g · 5 483 HP · +145 income",
    "tags": [
      "Air"
    ],
    "gate": {
      "id": "t2_b1_airmount",
      "label": "Technology",
      "techName": "Air Mount"
    },
    "details": [
      [
        "Cost",
        "1 650 g"
      ],
      [
        "HP per body",
        "5 483"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+145"
      ],
      [
        "Speed",
        "2 cells/s"
      ],
      [
        "Flies",
        "Yes"
      ]
    ]
  },
  "juggernaut": {
    "key": "juggernaut",
    "name": "Juggernaut",
    "kind": "unit",
    "tier": 2,
    "summary": "3 000 g · 18 780 HP · +302 income",
    "tags": [],
    "gate": {
      "id": "t2_b2_juggernaut",
      "label": "Technology",
      "techName": "Juggernaut"
    },
    "details": [
      [
        "Cost",
        "3 000 g"
      ],
      [
        "HP per body",
        "18 780"
      ],
      [
        "Armor",
        "5"
      ],
      [
        "Income",
        "+302"
      ],
      [
        "Speed",
        "1.5 cells/s"
      ]
    ]
  },
  "raider": {
    "key": "raider",
    "name": "Raider",
    "kind": "unit",
    "tier": 2,
    "summary": "3 000 g · 8 448 HP · +76 income",
    "tags": [
      "Attack"
    ],
    "gate": {
      "id": "t2_b2_raider",
      "label": "Technology",
      "techName": "Raider"
    },
    "details": [
      [
        "Cost",
        "3 000 g"
      ],
      [
        "HP per body",
        "8 448"
      ],
      [
        "Armor",
        "5"
      ],
      [
        "Income",
        "+76"
      ],
      [
        "Speed",
        "2 cells/s"
      ],
      [
        "Attack damage",
        "40"
      ],
      [
        "Attack range",
        "1 cells"
      ],
      [
        "Attack cooldown",
        "2.0 s"
      ],
      [
        "Attack DPS",
        "20"
      ]
    ]
  },
  "duelist": {
    "key": "duelist",
    "name": "Duelist",
    "kind": "unit",
    "tier": 3,
    "summary": "5 000 g · 23 178 HP · +473 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "5 000 g"
      ],
      [
        "HP per body",
        "11 589"
      ],
      [
        "Send count",
        "2"
      ],
      [
        "Total HP per send",
        "23 178"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+473"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "berserker": {
    "key": "berserker",
    "name": "Berserker",
    "kind": "unit",
    "tier": 3,
    "summary": "10 000 g · 24 328 HP · +148 income",
    "tags": [
      "Attack"
    ],
    "gate": null,
    "details": [
      [
        "Cost",
        "10 000 g"
      ],
      [
        "HP per body",
        "12 164"
      ],
      [
        "Send count",
        "2"
      ],
      [
        "Total HP per send",
        "24 328"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+148"
      ],
      [
        "Speed",
        "2 cells/s"
      ],
      [
        "Attack damage",
        "31"
      ],
      [
        "Attack range",
        "1 cells"
      ],
      [
        "Attack cooldown",
        "2.0 s"
      ],
      [
        "Attack DPS",
        "16"
      ]
    ]
  },
  "paladin": {
    "key": "paladin",
    "name": "Paladin",
    "kind": "unit",
    "tier": 3,
    "summary": "22 000 g · 150 768 HP · +1 745 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "22 000 g"
      ],
      [
        "HP per body",
        "150 768"
      ],
      [
        "Armor",
        "5"
      ],
      [
        "Income",
        "+1 745"
      ],
      [
        "Speed",
        "1.5 cells/s"
      ]
    ]
  },
  "griffinRider": {
    "key": "griffinRider",
    "name": "Griffin Rider",
    "kind": "unit",
    "tier": 3,
    "summary": "45 000 g · 178 815 HP · +1 638 income",
    "tags": [
      "Air"
    ],
    "gate": null,
    "details": [
      [
        "Cost",
        "45 000 g"
      ],
      [
        "HP per body",
        "178 815"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+1 638"
      ],
      [
        "Speed",
        "2 cells/s"
      ],
      [
        "Flies",
        "Yes"
      ]
    ]
  },
  "minotaurs": {
    "key": "minotaurs",
    "name": "Minotaurs",
    "kind": "unit",
    "tier": 4,
    "summary": "75 000 g · 420 210 HP · +5 134 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "75 000 g"
      ],
      [
        "HP per body",
        "140 070"
      ],
      [
        "Send count",
        "3"
      ],
      [
        "Total HP per send",
        "420 210"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+5 134"
      ],
      [
        "Speed",
        "2 cells/s"
      ]
    ]
  },
  "behemoth": {
    "key": "behemoth",
    "name": "Behemoth",
    "kind": "unit",
    "tier": 4,
    "summary": "135 000 g · 394 064 HP · +687 income",
    "tags": [
      "Attack"
    ],
    "gate": null,
    "details": [
      [
        "Cost",
        "135 000 g"
      ],
      [
        "HP per body",
        "394 064"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+687"
      ],
      [
        "Speed",
        "2 cells/s"
      ],
      [
        "Attack damage",
        "89"
      ],
      [
        "Attack range",
        "1 cells"
      ],
      [
        "Attack cooldown",
        "2.0 s"
      ],
      [
        "Attack DPS",
        "45"
      ]
    ]
  },
  "wyvern": {
    "key": "wyvern",
    "name": "Wyvern",
    "kind": "unit",
    "tier": 4,
    "summary": "250 000 g · 1 066 737 HP · +7 384 income",
    "tags": [
      "Air"
    ],
    "gate": null,
    "details": [
      [
        "Cost",
        "250 000 g"
      ],
      [
        "HP per body",
        "1 066 737"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+7 384"
      ],
      [
        "Speed",
        "2 cells/s"
      ],
      [
        "Flies",
        "Yes"
      ]
    ]
  },
  "warGolem": {
    "key": "warGolem",
    "name": "War Golem",
    "kind": "unit",
    "tier": 4,
    "summary": "450 000 g · 4 001 098 HP · +24 745 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "450 000 g"
      ],
      [
        "HP per body",
        "4 001 098"
      ],
      [
        "Armor",
        "10"
      ],
      [
        "Income",
        "+24 745"
      ],
      [
        "Speed",
        "1.5 cells/s"
      ]
    ]
  },
  "shinigami": {
    "key": "shinigami",
    "name": "Shinigami",
    "kind": "unit",
    "tier": 5,
    "summary": "1 000 000 g · 5 164 609 HP · +50 000 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "1 000 000 g"
      ],
      [
        "HP per body",
        "5 164 609"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+50 000"
      ],
      [
        "Speed",
        "2.6 cells/s"
      ]
    ]
  },
  "dragon": {
    "key": "dragon",
    "name": "Dragon",
    "kind": "unit",
    "tier": 5,
    "summary": "1 200 000 g · 5 714 120 HP · +29 345 income",
    "tags": [
      "Air"
    ],
    "gate": null,
    "details": [
      [
        "Cost",
        "1 200 000 g"
      ],
      [
        "HP per body",
        "5 714 120"
      ],
      [
        "Armor",
        "0"
      ],
      [
        "Income",
        "+29 345"
      ],
      [
        "Speed",
        "2 cells/s"
      ],
      [
        "Flies",
        "Yes"
      ]
    ]
  },
  "titan": {
    "key": "titan",
    "name": "Titan",
    "kind": "unit",
    "tier": 5,
    "summary": "1 400 000 g · 12 830 571 HP · +67 203 income",
    "tags": [],
    "gate": null,
    "details": [
      [
        "Cost",
        "1 400 000 g"
      ],
      [
        "HP per body",
        "12 830 571"
      ],
      [
        "Armor",
        "25"
      ],
      [
        "Income",
        "+67 203"
      ],
      [
        "Speed",
        "1.5 cells/s"
      ]
    ]
  },
  "colossus": {
    "key": "colossus",
    "name": "Colossus",
    "kind": "unit",
    "tier": 5,
    "summary": "1 500 000 g · 7 253 213 HP · +0 income",
    "tags": [
      "Attack"
    ],
    "gate": null,
    "details": [
      [
        "Cost",
        "1 500 000 g"
      ],
      [
        "HP per body",
        "7 253 213"
      ],
      [
        "Armor",
        "5"
      ],
      [
        "Income",
        "+0"
      ],
      [
        "Speed",
        "1.5 cells/s"
      ],
      [
        "Attack damage",
        "120"
      ],
      [
        "Attack range",
        "1 cells"
      ],
      [
        "Attack cooldown",
        "2.0 s"
      ],
      [
        "Attack DPS",
        "60"
      ]
    ]
  }
};
